module.exports = __webpack_public_path__ + "static/media/JAPAN-Nagoya.99dd8233.png";